import type { NavigationItem, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'BrotherKajko Personal Training',
    description: 'Individuelles Personal Training und Coaching für Muskelaufbau, weniger Körperfett und mehr Fitness. Persönlich begleitet, mit klarem Plan.',
    // Fallback address for canonical links. The "webseite" field in the CMS settings takes precedence.
    url: 'https://brotherkajko-personal-training.modulify.website',
    locale: 'de_DE'
}

export const mainNavigation: Array<NavigationItem> = [
    { label: 'Startseite', href: '/' },
    { label: 'Über mich', href: '/ueber-mich' },
    { label: 'Coaching', href: '/coaching' },
    { label: 'Ergebnisse', href: '/ergebnisse' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Kontakt', href: '/kontakt' }
]

export const legalNavigation: Array<NavigationItem> = [
    { label: 'Impressum', href: '/impressum' },
    { label: 'Datenschutz', href: '/datenschutz' }
]
